import React from 'react'
import Tilt from 'react-tilt'
import Typical from "react-typical"
import Spline from '@splinetool/react-spline';
import Loader from 'react-loaders'

function Experience() {
  return (
    <>
    <div className='sm:w-[50vw] md:w-full h-full'>
      
          
      <Spline scene="https://prod.spline.design/2zGCindgrSN4KtTF/scene.splinecode" />
    </div>
    <Loader type='ball-scale-multiple'/>
    </>

         
        
       
        
          


  )
}

export default Experience